module.exports = __webpack_public_path__ + "media/audio2.cfb95dce.mp3";